const messages = {
  "ui.avatar.tooltip.open": "Open {name}",
} as const;

export default messages;
